import { render, staticRenderFns } from "./showInventory.vue?vue&type=template&id=1b0cb299"
import script from "./showInventory.vue?vue&type=script&lang=js"
export * from "./showInventory.vue?vue&type=script&lang=js"
import style0 from "./showInventory.vue?vue&type=style&index=0&id=1b0cb299&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_qhqm3mauky62uixplfzayyuc5e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports